import { useMemo } from 'react';
import { addMonths, isWithinInterval, parseISO } from 'date-fns';
import type { SubscriptionPlanDetail } from 'types/Merchant';

export default function useSubscriptionPlan(
  subscriptionPlans: SubscriptionPlanDetail[]
) {
  return useMemo(() => {
    const now = new Date();
    const currentPlan = subscriptionPlans.find((plan) => {
      return (
        plan.type === 'financial_report' &&
        isWithinInterval(now, {
          start: parseISO(plan.startDate),
          end: parseISO(plan.endDate)
        })
      );
    });

    const initialStartDate = currentPlan
      ? new Date(currentPlan.startDate)
      : subscriptionPlans.length === 0
      ? now
      : new Date(subscriptionPlans[0].startDate);

    const initialEndDate = currentPlan
      ? new Date(currentPlan.endDate)
      : subscriptionPlans.length === 0
      ? addMonths(now, 1)
      : new Date(subscriptionPlans[0].endDate);

    return {
      currentPlan,
      initialStartDate,
      initialEndDate
    };
  }, [subscriptionPlans]);
}
